<div class="custom-loader">
  @for (item of loaderItems; track item.id) {
    <div></div>
  }
</div>